import { ForemanCrewAssignment } from './foreman-crew-assignment.model';
import { ForemanEmployeeLabor } from './foreman-employee-labor.model';
import { ForemanEmployee } from './foreman-employee.model';
import { SpartaEmployeeLabor } from './sparta-employee-labor.model';

export interface ForemanEmployeeDispatch {
  foremanEmployeeJobID: string;
  /** Sparta employee id when API flattens it on the dispatch row (nested `employee` may be absent). */
  employeeID?: string | null;
  employeeJobID?: string;
  manPowerReqDetailID?: string;
  foremanEmployeeID?: string;
  firstName: string;
  lastName: string;
  last4SSN?: string;
  craft: string;
  class: string;
  shift: number;
  shiftName: string;
  dispatchStatusID: number;
  dispatchStatus: string;
  foremanPhaseID: string;
  foremanPhaseName: string;
  foremanPhaseIDs?: string[];
  foremanPhaseNames?: string[];
  startDate: Date;
  endDate: Date;
  rofDate: Date;
  lastDayOnSite: Date;
  labors: ForemanEmployeeLabor[];
  spartaLabors: SpartaEmployeeLabor[];
  totalHoursWorked: number;
  employee: ForemanEmployee;
  foremanCrews?: ForemanCrewAssignment[];
  isSelectedForemanCrewMember?: boolean;
  bActive?: boolean;
  /**
   * Server-owned UTC instant the dispatch row was created/last changed
   * (`ForemanEmployeeJob.ModifiedDate`). This is the "recently dispatched"
   * signal — a real assignment event, unlike the scheduled `startDate`/`endDate`.
   */
  modifiedDate?: Date | string | null;
}
